export default function CtaBand() {
  return (
    <section className="py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="reveal relative overflow-hidden rounded-2xl border border-background-200">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20cinema%20background%2C%20warm%20amber%20and%20crimson%20gradient%20with%20soft%20light%20rays%20and%20film%20grain%20texture%2C%20elegant%20minimal%20composition%2C%20no%20text%2C%20premium%20editorial%20backdrop%2C%20high%20detail&width=1600&height=760&seq=cta-band-01&orientation=landscape"
              alt=""
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/65 to-foreground-950/35"></div>
          </div>

          <div className="relative flex flex-col gap-6 p-7 md:flex-row md:items-center md:justify-between md:p-10">
            <div className="max-w-2xl">
              <p className="text-xs uppercase tracking-widest text-accent-300">
                Master Brother Streaming
              </p>
              <h2 className="mt-3 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                想看的剧，就从这一页开始追
              </h2>
              <p className="mt-3 text-sm leading-7 text-background-100/85 md:text-base">
                热播推荐、新剧上线、分类浏览与追剧日历都在同一页，切换题材、加入清单、挑好清晰度，剩下的交给连播。
              </p>
            </div>
            <div className="flex flex-col gap-3 sm:flex-row md:shrink-0">
              <a
                href="#hot"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-fill text-lg"></i>
                浏览热播剧集
              </a>
              <a
                href="#guide"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-100/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-book-open-line text-lg"></i>
                查看追剧指南
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}